import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverCommercialIntentViewModel } from '../models/driver-commercial-intent-view.model';
import { IDriverCommercialIntentStatusType } from '../models/enums/driver-commercial-intent-status-type.enum';
import { IDriverCommercialIntentType } from '../models/enums/driver-commercial-intent-type.enum';

@Injectable()
export class DriverCommercialIntentService extends BaseApiService {
    public saveAndValidate = (model: DriverCommercialIntentViewModel, uploadedDocumentId: number = 0): Observable<boolean> =>
        this.post(`Driver/DriverCommercialIntent/${uploadedDocumentId}`, model);

    public remove = (driverCommercialIntentId: number): Observable<boolean> =>
        this.delete(`Driver/DriverCommercialIntent/${driverCommercialIntentId}`);

    public getCustomerDriverCommercialIntentHistory = (customerNumberId: number): Observable<DriverCommercialIntentViewModel[]> =>
        this.get(`Driver/DriverCommercialIntent/History/${customerNumberId}`).pipe(map(result => result.result));

    public getCustomerCurrentCommercialIntent = (customerNumberId: number): Observable<DriverCommercialIntentViewModel> =>
        this.get(`Driver/DriverCommercialIntent/${customerNumberId}`).pipe(map(result => result.result));

    public getDriverCommercialIntentTypes = (activeOnly: boolean = true): Observable<IDriverCommercialIntentType[]> =>
        this.get(`Driver/DriverCommercialIntent/Types/${activeOnly}`).pipe(map(result => result.result));

    public getDriverCommercialIntentStatusTypes = (activeOnly: boolean = true): Observable<IDriverCommercialIntentStatusType[]> =>
        this.get(`Driver/DriverCommercialIntent/StatusTypes/${activeOnly}`).pipe(map(result => result.result));
}
